import {
  SEARCH_APP_SUCCESS,
  SEARCH_WALLPAPER_SUCCESS,
  SEARCH_POST_SUCCESS,
  SEARCH_COURSE_SUCCESS,
  UPDATE_SEARCH_PARAM,
  UPDATE_SEARCH_COUNT,
  SEARCH_WALLPAPER_HOT_SUCCESS,
  SEARCH_POST_HOT_SUCCESS,
  SEARCH_COURSE_HOT_SUCCESS,
} from '../constants/searchResult';

const initState = {
  searchParam: {
    searchWord: '',
    searchMode: '0',
    activeTab: '',
    sortTypeSel: '0',
    softCategorySel: '0',
    wallpaperDpiSel: '0',
    wallpaperPaySel: '0',
    postTypeSel: '0',
    coursePaySel: '0',
  },
  searchCount: {
    appsCount: 0,
    coursesCount: 0,
    postsCount: 0,
    wallpapersCount: 0,
  },
  searchSoft: {},
  searchWallpaper: {},
  searchPost: {},
  searchCourse: {},
  searchWallpaperHot: {},
  searchPostHot: [],
  searchCourseHot: {},
};

const searchResult = (state = initState, action = {}) => {
  switch (action.type) {
    case UPDATE_SEARCH_PARAM:
      return { ...state, searchParam: action.payload };
    case UPDATE_SEARCH_COUNT:
      return { ...state, searchCount: action.payload };
    case SEARCH_APP_SUCCESS:
      return { ...state, searchSoft: action.payload };
    case SEARCH_WALLPAPER_SUCCESS:
      return { ...state, searchWallpaper: action.payload };
    case SEARCH_POST_SUCCESS:
      return { ...state, searchPost: action.payload };
    case SEARCH_COURSE_SUCCESS:
      return { ...state, searchCourse: action.payload };
    case SEARCH_WALLPAPER_HOT_SUCCESS:
      return { ...state, searchWallpaperHot: action.payload };
    case SEARCH_POST_HOT_SUCCESS:
      return { ...state, searchPostHot: action.payload };
    case SEARCH_COURSE_HOT_SUCCESS:
      return { ...state, searchCourseHot: action.payload };
    default:
      return state;
  }
};

export default searchResult;
